import { render, staticRenderFns } from "./DeleteGroup.vue?vue&type=template&id=ec4663e0&scoped=true&"
import script from "./DeleteGroup.vue?vue&type=script&lang=js&"
export * from "./DeleteGroup.vue?vue&type=script&lang=js&"
import style0 from "./DeleteGroup.vue?vue&type=style&index=0&id=ec4663e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4663e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec4663e0')) {
      api.createRecord('ec4663e0', component.options)
    } else {
      api.reload('ec4663e0', component.options)
    }
    module.hot.accept("./DeleteGroup.vue?vue&type=template&id=ec4663e0&scoped=true&", function () {
      api.rerender('ec4663e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/DeleteGroup.vue"
export default component.exports